export type TypeStop = {
  offset: number,
  color: string,
  opacity: number
}
export type ShadowType = {
  cx: number,
  r: number,
  cy: number
  fr?: number,
  fy?: number,
  fx?: number,
  stop: TypeStop[]
}

export const defaultShadow: ShadowType = {
  cx: 50,
  r: 75,
  cy: 50,
  stop: [
    {
      offset: 42,
      color: 'rgba(255, 255, 255, 0.00)',
      opacity: 0

    },
    {
      offset: 100,
      color: 'rgba(255, 255, 255, 1)',
      opacity: 100
    }
  ]
}


export const radioShadow: ShadowType = {
  cx: 40,
  r: 85,
  cy: 60,
  stop: [
    {
      offset: 60,
      color: 'rgba(255, 255, 255, 0.00)',
      opacity: 100

    },
    {
      offset: 100,
      color: 'rgba(255, 255, 255, 1)',
      opacity: 100
    }
  ]
}

export const checkboxShadow: ShadowType = {
  cx: 50,
  cy: 50,
  r: 63,
  stop: [
    {
      offset: 70,
      color: 'rgba(255, 255, 255, 0.00)',
      opacity: 30

    },
    {
      offset: 80,
      color: 'rgba(255, 255, 255, 1)',
      opacity: 100
    }
  ]
}
